import React, { useEffect, useState } from 'react';
import { connect } from "react-redux";
import { Redirect } from 'react-router-dom';
import { GetGateDetails, GetGateTimes, DeleteGate, GetQueuedActions, ClearGates } from '../../store/actions/gateActions'; 
import { Menu, Spin, Button, Slider } from 'antd';
import 'antd/dist/antd.css';
import _ from "lodash";
import GateSettings from './tabs/GateSettings';
import GateDiagnostic from './tabs/GateDiagnostic';
import GateSchedule from './tabs/GateSchedule';
import GateEventLog from './tabs/GateEventLog';
import GateErrorLog from './tabs/GateErrorLog';
import GateUsers from './tabs/GateUsers';

function GateDetails(props) {
    const [gateData, setGateData]   = useState({});
    const [gateUsers, setGateUsers] = useState([]);
    const [isLoading, setLoading]   = useState(true);
    const [isDeleting, gateDelete]  = useState(false);
    const [tab, setTab]             = useState("settings");
    const [deleteScale, setDelete]  = useState(0);
    const gate_id = props.match.params.id;
                                      
    useEffect(() => {
        const subActions = async () => {
            return await props.GetQueuedActions(gate_id);
        }
        let unsubQueue = subActions();
        return async () => {
            let unsubQ = await unsubQueue; 
            unsubQ();
            await props.ClearGates();
        };
    },[]);
    
    useEffect(() => {
        if( isLoading ) {
            if( _.isEmpty(props.gate) ) { 
                //Get Gate Data if Loading and No Gate has been loaded
                props.GetGateDetails(gate_id);
            } else if( gateData !== props.gate && _.isEmpty(gateData) ) {
                //Set State of Loaded Gate Data
                setGateData(props.gate);
                setLoading(false);
            }
        }
    },[props.gate]);

    const handleDelete = () => {
        if(deleteScale === 100) {
            gateDelete(true);
            props.DeleteGate(gate_id);
        } else {
            alert("To delete gate, please move scale to 100");
        }
    }

    if( gateData.exists === false ) {
        return <Redirect push to={`/admin/`} />;
    }

    if( isLoading ) 
        return (
            <div className="container gateDetail">
                <div className="row" style={{ marginBottom: "0"}}>
                    <div className="col s6" style={{display: "flex", alignItems: "center", justifyContent: "center"}}>
                        <Spin size="large" />
                    </div>
                </div>
            </div>
        );
    return (
        <div className="container gateDetail">
            <h1>{gateData.name}</h1>
            <div className="row" style={{ marginBottom: "0"}}>
                <div className="col s6">
                    <Menu onClick={(e) => setTab(e.key) } selectedKeys={[tab]} mode="horizontal">
                        <Menu.Item key="settings">
                            Settings
                        </Menu.Item>                            
                        <Menu.Item key="time">
                            Schedule
                        </Menu.Item>
                        <Menu.Item key="users" >
                            Users
                        </Menu.Item>
                        <Menu.Item key="error" >
                            Errors
                        </Menu.Item>
                        <Menu.Item key="log" >
                            Event Logs
                        </Menu.Item>                        
                        <Menu.Item key="diagnostic" >
                            Diagnostic
                        </Menu.Item>
                        <Menu.Item key="delete" >
                            Delete
                        </Menu.Item>
                    </Menu>
                    <div>
                        { tab === "settings" && <GateSettings gate={gateData} id={props.match.params.id} /> }
                        { tab === "time" && <GateSchedule /> }
                        { tab === "users" && <GateUsers /> }
                        { tab === "error" && <GateErrorLog /> }
                        { tab === "log" && <GateEventLog gate_id={props.match.params.id} /> }
                        { tab === "diagnostic" && <GateDiagnostic gate_id={props.match.params.id} /> }
                        { tab === "delete" && 
                            <div className="gateDelete">
                                <p>Slide to 100 to confirm <strong>deletion</strong></p>
                                <div style={{width: "50%"}}>
                                    <Slider defaultValue={0} onChange={(value) => setDelete(value)} />
                                </div>
                                <Button type="danger" loading={isDeleting} onClick={handleDelete}>Confirm Delete</Button>
                            </div> 
                        }
                    </div>
                </div>
            </div>
        </div>
    );
    
}

const mapStateToProps = (state) => {
    return {
        gate:    state.gate.gate,
        time:    state.gate.times,
        users:   state.gate.users
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        ClearGates:              () => dispatch(ClearGates()),
        GetGateDetails:   (gate_id) => dispatch(GetGateDetails(gate_id)),
        GetGateTimes:     (gate_id) => dispatch(GetGateTimes(gate_id)),
        DeleteGate:       (gate_id) => dispatch(DeleteGate(gate_id)),
        GetQueuedActions: (gate_id) => dispatch(GetQueuedActions(gate_id)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(GateDetails);
